module.exports = __webpack_public_path__ + "img/best-price-image.png";